module.exports = __webpack_public_path__ + "static/media/logo.06d3a66f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/logo.svg
// module id = 221
// module chunks = 0